import Container from '~/components/container/Container';
import NoContent from '~/components/noContent/NoConTent';

function AlbumUsuk() {
    return (
        <Container>
            <NoContent />
        </Container>
    );
}

export default AlbumUsuk;
